/**
 * Created by Colin.Watson on 4/2/2015.
 */
(function () {
	'use strict';
	angular.module('blocks.exception', ['blocks.logger']);
})();
